import type { ImageLoaderProps } from '../../types/types'
import { getImageFeaturedHeight } from '../../utils/getImageFeaturedHeight/getImageFeaturedHeight'
import { getImageSrc } from '../../utils/getImageSrc/getImageSrc'
import { getImageWidth } from '../../utils/getImageWidth/getImageWidth'

export const smartCropFeaturedLoader = ({ src, width }: ImageLoaderProps) => {
	const viewportWidth = getImageWidth(width)
	const viewportHeight = getImageFeaturedHeight({ width: viewportWidth })

	const url = getImageSrc({ src })

	const searchParams = new URLSearchParams({
		wid: viewportWidth.toString(),
		hei: viewportHeight.toString(),
		fit: 'crop',
	})

	url.search = searchParams.toString()

	return url.toString()
}
